<template>
    <router-view :key="$route.fullPath"></router-view>
    <!-- <footer-two></footer-two> -->
</template>